import { keyframes, styled } from "@mui/material"
import { DataGridPremium, gridClasses } from "@mui/x-data-grid-premium"
import { GO_TO_FINDER_GUTTER, GO_TO_ROW_FLASH_DURATION_MS } from "../constants"

const goToRowFlash = keyframes({
  "0%": { backgroundColor: "var(--app-opcolor-yellow-light)" },
  "100%": { backgroundColor: "transparent" },
})

export const GoToFinderDataGrid = styled(DataGridPremium)(({ theme }) => ({
  // renderHeader only reaches the title container, so the icon is positioned against the
  // header cell itself and needs a gutter reserved here.
  [`& .${gridClasses.columnHeader}.has-go-to-finder`]: {
    position: "relative",
    paddingLeft: theme.spacing(GO_TO_FINDER_GUTTER),
  },

  // Lift the searching cell over its neighbour so the overhanging input clears the divider.
  [`& .${gridClasses.columnHeader}.go-to-finder-searching`]: {
    zIndex: theme.zIndex.appBar - 1,
    [`& .${gridClasses.menuIcon}, & .MuiCustomHeader-sortIcon, & .${gridClasses.columnSeparator}`]: {
      display: "none",
    },
  },

  // Animate the cells, not the row: pinned cells are deliberately opaque, and an animated
  // property outranks their normal background-color declaration regardless of specificity.
  [`& .${gridClasses.row}.go-to-row-flash .${gridClasses.cell}`]: {
    animation: `${goToRowFlash} ${GO_TO_ROW_FLASH_DURATION_MS}ms ease-out forwards`,
    "@media (prefers-reduced-motion: reduce)": { animation: "none" },
  },
}))
